import React, { Fragment, useEffect, useState, useRef, useMemo } from "react";
import swalMessage from "@sweetalert/with-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import {
  fCurrency,
  fNumber,
  isFloat,
  fFloat,
  fFloatWithoutComma,
} from "../../../utils/formatNumber";
import PageTitle from "../../layouts/PageTitle";
import { orderActions } from "../../../_store";
import BarcodeReader from "react-barcode-reader";
import Toastr from "../../components/common/Toastr";
import { ToastContainer } from "react-toastify";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import WeightVerificationPopup from "../../components/common/Order/WeightVerification/WeightVerificationPopup";

const WeightVerification = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listView = location.state;
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region Reducers ------------------  Reducers --------------------------------

  const { orderDetail, lotDetailList, orderPreparationResponse } = useSelector(
    (state) => state.order,
  );
  const currentUser = useSelector((x) => x.auth.user);

  // #endregion Reducers ------------------  Reducers End --------------------------------

  const [barcodeVerifySKU, setBarcodeVerifySKU] = useState("");
  const refBarcodeVerifySKU = useRef("");
  const refEstimatedWeight = useRef("");

  const [serialPort, setSerialPort] = useState(null);
  const [reader, setReader] = useState(null);
  const [weight, setWeight] = useState("");
  const [isBackButton, setBackButton] = useState(true);

  const [weightVerifyFinally, setWeightVerifyFinally] = useState("");
  const [isRevealPwd, setIsRevealPwd] = useState(false);

  const [isShortDescModal, setShortDescModal] = useState(false);

  const [sortConfig, setSortConfig] = useState({
    key: "Location",
    direction: "asc",
  });

  const [popupData, setPopupData] = useState({});
  //const [isPackagesPerBox, setPackagesPerBox] = useState(false);
  const [packagesPerBox, setPackagesPerBox] = useState({
    isPackagesPerBox: false,
    isAdminPasscodeValid: false,
    AdminPasscode: "",
    ProductName: "",
    ProductPerBoxCount: "",
    OrderPerBoxCount: "",
    index: null,
    OrderProductID: 0,
  });

  const [orderPreparation, setOrderPreparation] = useState({
    OrderID: listView.OrderID,
    TotalEstimatedWeight: 0,
    LotNumber: 0,
    CreatedBy: currentUser.Id,
    TypeOrderPreparationProductModel: [],
    TypeOrderProductBoxDetailModel: [],
  });

  const orderPreparationData = { ...orderPreparation };

  // Product/Location sorting — same toggle cycle (asc -> desc -> unsorted)
  // and arrow icons as OrderList's OrderTable (react-table useSortBy default)
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key !== key) return { key, direction: "asc" };
      if (prev.direction === "asc") return { key, direction: "desc" };
      return { key: null, direction: "asc" };
    });
  };

  const sortedOrderProductModelList = useMemo(() => {
    const list = orderDetail?.OrderProductModelList
      ? [...orderDetail.OrderProductModelList]
      : [];
    if (!sortConfig.key) return list;
    return list.sort((a, b) => {
      const valA = (a[sortConfig.key] || "").toString().toLowerCase();
      const valB = (b[sortConfig.key] || "").toString().toLowerCase();
      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [orderDetail, sortConfig]);

  const handleScan = (data) => {
    setBarcodeVerifySKU(data);
    refBarcodeVerifySKU.current = data;

    console.log("handle Scan data : " + data);

    let orderDetailData = { ...orderDetail };
    let newFormData = [...orderDetailData.OrderProductModelList];
    let NewRowData = newFormData.filter(
      (d) => d.SKU.toLowerCase() === (data && data.toLowerCase()),
    );

    if (NewRowData && NewRowData[0]) {
      let rowData = { ...NewRowData[0] };
      rowData.IsSKUVerify = true;

      let index = newFormData.findIndex(
        (x) => x.SKU.toLowerCase() === (data && data.toLowerCase()),
      );

      console.log("index", index);

      if (!isFloat(rowData.SplitBoxCount)) {
        rowData.IsPreparedWeightVerify = true;
        rowData.EstimatedWeight = rowData.Weight * rowData.Quantity;
      }

      newFormData[index] = rowData;
      orderDetailData.OrderProductModelList = newFormData;

      const sumEstimatedWeight =
        orderDetailData &&
        orderDetailData.OrderProductModelList.reduce((accumulator, object) => {
          let EstimatedWeightVal = 0;
          let oldVal = 0;
          if (!EstimatedWeightVal) {
            oldVal = parseFloat(accumulator);
          }

          if (object.EstimatedWeight) {
            EstimatedWeightVal = parseFloat(object.EstimatedWeight);
          }

          return oldVal + EstimatedWeightVal;
        }, 0);
      orderPreparationData.TotalEstimatedWeight = sumEstimatedWeight;
      setOrderPreparation(orderPreparationData);

      dispatch(orderActions.tempSetOrderWeightVerification(orderDetailData));
      const scannedRowElement = document.querySelector(
        `tr[data-order-product-id="${rowData.OrderProductID}"]`,
      );
      if (scannedRowElement) {
        scannedRowElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    } else {
      // Toastr('SKU is not matched ', "warning");

      swalMessage(
        <div>
          <h2>SKU is not matched!!</h2>
        </div>,
      );
    }
  };
  const handleError = (err) => {
    Toastr(err, "warning");
    // console.error(err);
  };

  useEffect(() => {
    connectToSerialPort();
  }, []);

  const connectToSerialPort = async () => {
    if (isBackButton === false) {
      setBackButton(true);
    }

    try {
      console.log("connect To Serial Port.");
      console.log(
        "connect refBarcodeVerifySKU :" + refBarcodeVerifySKU.current,
      );

      const port = await navigator.serial.requestPort();
      await port.open({ baudRate: 9600 }); // Adjust baudRate as needed
      setSerialPort(port);

      const newReader = port.readable.getReader();
      setReader(newReader);

      readData(newReader);
    } catch (error) {
      setBackButton(false);

      console.log("Error accessing serial port:" + error && error.message);
      let msg = "Error accessing serial port " + error && error.message;

      Toastr(msg, "warning");
    }
  };

  const readData = async (reader) => {
    setBackButton(false);

    try {
      console.log("-----------read Data------------------------");

      console.log(
        "read Data refBarcodeVerifySKU :" + refBarcodeVerifySKU.current,
      );

      let allValue = "";
      while (true) {
        const { value, done } = await reader.read();
        if (done) {
          allValue = "";
          break;
        }

        let textValue = new TextDecoder().decode(value);
        allValue = allValue + textValue;

        console.log("AllValue :" + allValue);

        if (allValue) {
          let newOne = allValue.trim();

          //Pounds-lb
          if (newOne.includes("Net") && newOne.endsWith("lb")) {
            allValue = allValue.trim();
            let splitWeightData = allValue.split("  ");

            let lastData = splitWeightData[splitWeightData.length - 1];
            let resultReplace = lastData.replace("Net", "");
            let finalResult = resultReplace.replace("lb", "");
            setWeight(finalResult.trim());

            console.log("Final Result :" + finalResult.trim());
            allValue = "";
            let EstimatedWeight = parseFloat(finalResult.trim());

            let orderDetailData = { ...orderDetail };
            let newFormData = [...orderDetailData.OrderProductModelList];
            let NewRowData = newFormData.filter(
              (d) =>
                d.SKU.toLowerCase() ===
                (refBarcodeVerifySKU.current &&
                  refBarcodeVerifySKU.current.toLowerCase()),
            );

            console.log(
              "refBarcodeVerifySKU.current :" +
                refBarcodeVerifySKU.current.toLowerCase(),
            );

            if (NewRowData && NewRowData[0]) {
              let rowData = { ...NewRowData[0] };
              // let index = newFormData.findIndex(x => x.SKU === refBarcodeVerifySKU.current);

              // console.log('index :' + index);

              let orderTotalWeight =
                parseFloat(rowData.Weight) * parseFloat(rowData.Quantity);
              let minValue = orderTotalWeight - 0.5; // get total Weight adjustment (-0.5) condition check
              let maxValue = orderTotalWeight + 0.5; // get total Weight adjustment (+0.5) condition check

              if (
                !(minValue <= EstimatedWeight && maxValue >= EstimatedWeight)
              ) {
                // Total Weight adjustment (-+0.5) condition check
                //  Toastr('Weight mismatch  for sku ' + refBarcodeVerifySKU.current, "warning");
                swalMessage(
                  <div>
                    <h2>
                      Weight mismatch for sku {refBarcodeVerifySKU.current}
                    </h2>
                  </div>,
                );
              } else {
                refEstimatedWeight.current = EstimatedWeight;
                console.log(
                  refBarcodeVerifySKU.current +
                    "-" +
                    EstimatedWeight +
                    "-success",
                );

                setWeightVerifyFinally(
                  refBarcodeVerifySKU.current +
                    "-" +
                    EstimatedWeight +
                    "-success",
                );

                console.log("success");
              }
            } else {
              // Toastr('Please check SKU', "warning");
              swalMessage(
                <div>
                  <h2>Please check SKU!!</h2>
                </div>,
              );
            }
          }
        }
      }
    } catch (error) {
      console.log("Error reading data:" + error && error.message);
      Toastr("Error reading data : " + error && error.message, "warning");
      setBackButton(false);
    }
  };

  useEffect(() => {
    if (weightVerifyFinally) {
      console.log(
        refBarcodeVerifySKU.current +
          "-" +
          refEstimatedWeight.current +
          "-success",
      );

      let currentValue =
        refBarcodeVerifySKU.current +
        "-" +
        refEstimatedWeight.current +
        "-success";

      if (weightVerifyFinally === currentValue) {
        let orderDetailData = { ...orderDetail };
        let newFormData = [...orderDetailData.OrderProductModelList];
        let NewRowData = newFormData.filter(
          (d) =>
            d.SKU.toLowerCase() ===
            (refBarcodeVerifySKU.current &&
              refBarcodeVerifySKU.current.toLowerCase()),
        );
        let rowData = { ...NewRowData[0] };
        let index = newFormData.findIndex(
          (x) =>
            x.SKU.toLowerCase() ===
            (refBarcodeVerifySKU.current &&
              refBarcodeVerifySKU.current.toLowerCase()),
        );

        rowData.EstimatedWeight = parseFloat(refEstimatedWeight.current);
        rowData.IsPreparedWeightVerify = true;
        newFormData[index] = rowData;
        orderDetailData.OrderProductModelList = newFormData;
        console.log("Estimated Weight value update state ");

        const sumEstimatedWeight =
          orderDetailData &&
          orderDetailData.OrderProductModelList.reduce(
            (accumulator, object) => {
              let EstimatedWeightVal = 0;
              let oldVal = 0;
              if (!EstimatedWeightVal) {
                oldVal = parseFloat(accumulator);
              }

              if (object.EstimatedWeight) {
                EstimatedWeightVal = parseFloat(object.EstimatedWeight);
              }

              return oldVal + EstimatedWeightVal;
            },
            0,
          );
        orderPreparationData.TotalEstimatedWeight = sumEstimatedWeight;
        console.log("setOrderPreparation updated in state before");
        setOrderPreparation(orderPreparationData);
        console.log("setOrderPreparation updated in state");

        console.log("tempSetOrderWeightVerification updated in state before");
        dispatch(orderActions.tempSetOrderWeightVerification(orderDetailData));
        console.log("tempSetOrderWeightVerification updated in state");
      }
    }
  }, [weightVerifyFinally]);

  useEffect(() => {
    dispatch(
      orderActions.GetLotDetailsByOrderID({ OrderID: listView.OrderID }),
    );

    dispatch(orderActions.GetOrderDetailsByID({ OrderID: listView.OrderID }));
  }, [listView.OrderID]);

  const handleBack = async () => {
    if (serialPort) {
      await reader.cancel();
      await serialPort.close();
      setSerialPort(null);
      setWeight("");
    }
    navigate("/OrderList");
  };

  // handle Change function
  const handleChange = (event, orderProductID) => {
    // event.preventDefault();
    let orderDetailData = { ...orderDetail };
    let newFormData = [...orderDetailData.OrderProductModelList];
    const index = newFormData.findIndex(
      // (x) => x.OrderProductID === orderProductID,
      (x) => String(x.OrderProductID) === String(orderProductID),
    );

    if (index === -1) {
      return;
    }

    let rowData = { ...newFormData[index] };

    const regexString = /^[a-zA-Z\s]*$/;
    const regexNoSymbol = /^[A-Za-z0-9\b]+$/gm;
    const regexNumber = /^[0-9\b]+$/;
    const regexNumberAndComma = /^[0-9,\b]+$/;
    const regexDecimal = /^[+-]?((\d+(\.\d*)?)|(\.\d+))$/;
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "PreparedQuantity") {
        if (fieldValue === "" || regexNumber.test(fieldValue)) {
          rowData.PreparedQuantity = fieldValue.trim();
        }
        if (rowData.Quantity === parseInt(fieldValue && fieldValue)) {
          rowData.IsPreparedQtyError = false;
        } else {
          rowData.IsPreparedQtyError = true;
        }
      } else if (fieldName === "BoxNumbers") {
        if (fieldValue === "," || fieldValue === ",," || fieldValue === "0") {
          rowData.BoxNumbers = "";
        } else if (fieldValue === "" || regexNumberAndComma.test(fieldValue)) {
          rowData.BoxNumbers = fieldValue.trim();
        }
      } else if (fieldName === "EstimatedWeight") {
        if (fieldValue === "" || regexDecimal.test(fieldValue)) {
          rowData.EstimatedWeight = fieldValue.trim();
          rowData.IsPreparedWeightVerify = true;
        }
      } else if (fieldName === "LotNumber") {
        if (fieldValue === "" || regexNoSymbol.test(fieldValue)) {
          rowData.LotNumber = fieldValue.trim();
        }
      }
    } else {
      rowData[fieldName] = fieldValue.trim();
    }
    newFormData[index] = rowData;

    orderDetailData.OrderProductModelList = newFormData;
    if (fieldName === "EstimatedWeight") {
      const sumEstimatedWeight =
        orderDetailData &&
        orderDetailData.OrderProductModelList.reduce((accumulator, object) => {
          let EstimatedWeight = 0;
          if (object.EstimatedWeight) {
            EstimatedWeight = parseFloat(object.EstimatedWeight);
          }
          return parseFloat(accumulator) + EstimatedWeight;
        }, 0);

      orderPreparationData.TotalEstimatedWeight = sumEstimatedWeight;
      setOrderPreparation(orderPreparationData);
    }

    dispatch(orderActions.tempSetOrderWeightVerification(orderDetailData));
  };

  // handle Blur function
  const handleBlur = (event, orderProductID) => {
    let orderDetailData = { ...orderDetail };
    let newFormData = [...orderDetailData.OrderProductModelList];
    const index = newFormData.findIndex(
      // (x) => x.OrderProductID === orderProductID,
      (x) => String(x.OrderProductID) === String(orderProductID),
    );

    if (index === -1) {
      return;
    }

    let rowData = { ...newFormData[index] };
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "BoxNumbers") {
        if (fieldValue) {
          let BoxCount = Math.floor(rowData.SplitBoxCount);
          if (rowData.SplitBoxCount > 0) {
            let hasFloat = isFloat(rowData.SplitBoxCount);
            if (hasFloat) {
              BoxCount = BoxCount + 1;
            }

            if (fieldValue.includes(",")) {
              // --- Multiple box number----
              // if (BoxCount < 10) {
              let boxNumberList = fieldValue.split(",").map(Number); //main data
              let filterBoxNumberList = fieldValue.match(/[^,]+/g);
              if (boxNumberList.length !== filterBoxNumberList.length) {
                // check extra comma
                Toastr("Please enter a valid box number", "warning");

                rowData.IsBoxError = true;
              } else {
                if (boxNumberList.length !== BoxCount) {
                  // check extra Box Count
                  let msg = "";
                  if (BoxCount === 1) {
                    msg = "box";
                  } else {
                    msg = "boxes";
                  }
                  Toastr(
                    "Please enter correct value " +
                      BoxCount +
                      " " +
                      msg +
                      " number",
                    "warning",
                  );

                  rowData.IsBoxError = true;
                } else {
                  const uniqueBoxNumberList = Array.from(
                    new Set(boxNumberList),
                  );
                  if (boxNumberList.length !== uniqueBoxNumberList.length) {
                    // check extra duplicates
                    Toastr("Please avoid any duplicate box number", "warning");

                    rowData.IsBoxError = true;
                  } else {
                    let maxBoxCount = boxNumberList.find(
                      (box) => parseInt(box) === 0,
                    );
                    if (maxBoxCount === 0) {
                      Toastr("Please enter a valid box number", "warning");
                      rowData.IsBoxError = true;
                    } else {
                      rowData.IsBoxError = false;
                    }
                  }
                }
              }

              // rowData.IsPreparedWeightVerify = true;
              // rowData.EstimatedWeight = (rowData.Weight * rowData.Quantity);
              // } else {
              //   Toastr(
              //     "Total boxes " +
              //     BoxCount +
              //     "  Please add one box number for flight delivery mode",
              //     "warning"
              //   );

              //   rowData.IsBoxError = true;
              // }
            } // Single box number  flight type -----
            else {
              if (parseInt(fieldValue) === 0) {
                // Max box number 9
                Toastr("Please enter a valid box number", "warning");

                rowData.IsBoxError = true;
              } else if (BoxCount === 1 && fieldValue) {
                rowData.IsBoxError = false;
                // rowData.IsPreparedWeightVerify = true;
                // rowData.EstimatedWeight = (rowData.Weight * rowData.Quantity);
              } else {
                rowData.IsBoxError = true;
                let msg = "";
                if (BoxCount === 1) {
                  msg = "box";
                } else {
                  msg = "boxes";
                }
                Toastr(
                  "Please enter correct value " +
                    BoxCount +
                    " " +
                    msg +
                    " number",
                  "warning",
                );
              }
            }
          } else {
            Toastr("Kindly verify packages Per Box for a  Product", "warning");
            rowData.IsBoxError = true;
          }
        } else {
          Toastr("Please enter a box number", "warning");

          rowData.IsBoxError = true;
        }
      } else if (fieldName === "LotNumber") {
        let rowLotDetail = lotDetailList?.filter(
          (d) =>
            d.LotNumber.toLowerCase() ===
              (fieldValue.trim() && fieldValue.trim().toLowerCase()) &&
            rowData.ProductID === d.ProductID,
        );

        if (rowLotDetail?.[0]) {
          let lotVal = rowLotDetail?.[0];
          const currentDate = new Date();
          const expiredDate = new Date(lotVal.ExpiredDate);
          // Calculate the date 30 days before the expired date
          const thirtyDaysBefore = new Date(expiredDate);
          thirtyDaysBefore.setDate(expiredDate.getDate() - 30);
          // Set time components to zero to ignore time
          currentDate.setHours(0, 0, 0, 0);
          expiredDate.setHours(0, 0, 0, 0);
          thirtyDaysBefore.setHours(0, 0, 0, 0);

          if (currentDate > expiredDate) {
            rowData.WarrantyExpiryStatus = 1;
          } else if (currentDate >= thirtyDaysBefore) {
            rowData.WarrantyExpiryStatus = 2;
          } else {
            rowData.WarrantyExpiryStatus = 0;
          }
        } else {
          rowData.WarrantyExpiryStatus = 0;
        }
      } else {
        if (fieldName === "EstimatedWeight") {
          if (fieldValue) {
            rowData[fieldName] = fFloatWithoutComma(fieldValue);
          }
        }
      }
    }

    newFormData[index] = rowData;

    orderDetailData.OrderProductModelList = newFormData;
    dispatch(orderActions.tempSetOrderWeightVerification(orderDetailData));
  };

  // const checkLotNumber = (orderDetail) => {
  //   console.log(orderDetail);
  // };

  const handleSave = () => {
    // let checkLotNumber = false;
    let SKUVerifyChk = false;
    let PreparedQtyErrorChk = false;
    let BoxErrorChk = false;
    let PreparedWeightVerifyChk = false;
    let orderPreparationProductModel = [];
    let orderProductBoxDetailModel = [];
    showLoader();
    const isLotNumberIsEmpty = orderDetail.OrderProductModelList?.some(
      (item, index) => !item?.LotNumber,
    );

    if (isLotNumberIsEmpty) {
      hideLoader();
      Toastr("Please Fill All The Missing Fields", "warning");
      return;
    }

    for (let val of orderDetail.OrderProductModelList) {
      if (val.IsSKUVerify === false) {
        SKUVerifyChk = true;
        break;
      }

      if (
        val.IsPreparedQtyError === true ||
        !val.PreparedQuantity ||
        val.PreparedQuantity === 0
      ) {
        PreparedQtyErrorChk = true;
        break;
      }

      if (val.IsBoxError === true || !val.BoxNumbers) {
        BoxErrorChk = true;
        break;
      }

      if (val.IsPreparedWeightVerify === false || !val.EstimatedWeight) {
        PreparedWeightVerifyChk = true;
        break;
      }

      let orderTotalWeight = parseFloat(val.Weight) * parseInt(val.Quantity); // Total Weight in Product
      let minValue = orderTotalWeight - 0.5; // get total Weight adjustment (-0.5) condition check
      let maxValue = orderTotalWeight + 0.5; // get total Weight adjustment (+0.5) condition check

      let EstimatedWeight = parseFloat(val.EstimatedWeight);
      if (!(minValue <= EstimatedWeight && maxValue >= EstimatedWeight)) {
        // Total Weight adjustment (-+0.5) condition check
        PreparedWeightVerifyChk = true;
        break;
      }

      orderPreparationProductModel.push({
        OrderProductID: val.OrderProductID,
        EstimatedWeight: val.EstimatedWeight,
        BoxNumbers: val.BoxNumbers,
        LotNumber: val.LotNumber,
      }); // order Product insert

      let BoxCount = Math.floor(val.SplitBoxCount); // round Box Count
      let hasFloat = isFloat(val.SplitBoxCount); // check Box Count  has Float(22.2)
      if (hasFloat) {
        // Box Count
        BoxCount = BoxCount + 1;
      }

      // if (BoxCount < 10) {
      let boxNumberList = val.BoxNumbers.split(",");

      boxNumberList &&
        boxNumberList.map((BoxNumberData, index) => {
          // order Product Box insert

          if (index + 1 === boxNumberList.length && hasFloat) {
            // Add (Quantity/Weight) in Last Box Number

            const perBox = val.PerBoxCount;

            let roundBoxCount = Math.floor(val.SplitBoxCount);
            let remainingQuantity = val.Quantity - roundBoxCount * perBox;

            let TotalWeight = parseFloat(val.Weight) * remainingQuantity;
            orderProductBoxDetailModel.push({
              OrderProductID: val.OrderProductID,
              BoxNumber: BoxNumberData,
              Quantity: remainingQuantity,
              PerQuantityWeight: val.Weight,
              TotalWeight: TotalWeight,
            });
          } else {
            // Add (Quantity/Weight) in  Box Number (Per Quantity)

            const perBox = val.PerBoxCount;

            let TotalWeight = parseFloat(val.Weight) * parseInt(perBox);

            orderProductBoxDetailModel.push({
              OrderProductID: val.OrderProductID,
              BoxNumber: BoxNumberData,
              Quantity: perBox,
              PerQuantityWeight: val.Weight,
              TotalWeight: TotalWeight,
            });
          }
        });
      // } else {
      //   // order Product Box insert (1 box flight Type)
      //   orderProductBoxDetailModel.push({
      //     OrderProductID: val.OrderProductID,
      //     BoxNumber: val.BoxNumbers,
      //     Quantity: val.Quantity,
      //     PerQuantityWeight: val.Weight,
      //     TotalWeight: val.EstimatedWeight,
      //   });
      // }
    }

    if (SKUVerifyChk) {
      hideLoader();
      Toastr("Please Check SKU Scan Verification", "warning");
    } else if (PreparedQtyErrorChk) {
      hideLoader();
      Toastr("Please Check Prepared Quantity Count", "warning");
    } else if (BoxErrorChk) {
      hideLoader();
      Toastr("Please Check Box Number", "warning");
    } else if (PreparedWeightVerifyChk) {
      hideLoader();
      Toastr("Please Check the Prepared Weight ", "warning");
    } else {
      orderPreparation.TypeOrderPreparationProductModel =
        orderPreparationProductModel;
      orderPreparation.TypeOrderProductBoxDetailModel =
        orderProductBoxDetailModel;
      dispatch(orderActions.saveOrderPreparation(orderPreparation));
    }
  };

  const handleTemporarySave = () => {
    showLoader();
    let orderPreparationProductModel = [];

    for (let val of orderDetail.OrderProductModelList) {
      let SKUVerifyChk = false;
      let PreparedQtyErrorChk = false;
      let BoxErrorChk = false;
      let PreparedWeightVerifyChk = false;
      let IsPreparedVerify = true;

      if (val.IsSKUVerify === false) {
        SKUVerifyChk = true;
      }

      if (
        val.IsPreparedQtyError === true ||
        !val.PreparedQuantity ||
        val.PreparedQuantity === 0
      ) {
        PreparedQtyErrorChk = true;
      }

      if (val.IsBoxError === true || !val.BoxNumbers) {
        BoxErrorChk = true;
      }

      if (val.IsPreparedWeightVerify === false || !val.EstimatedWeight) {
        PreparedWeightVerifyChk = true;
      }

      let orderTotalWeight = parseFloat(val.Weight) * parseInt(val.Quantity); // Total Weight in Product
      let minValue = orderTotalWeight - 0.5; // get total Weight adjustment (-0.5) condition check
      let maxValue = orderTotalWeight + 0.5; // get total Weight adjustment (+0.5) condition check

      let EstimatedWeight = parseFloat(val.EstimatedWeight);
      if (!(minValue <= EstimatedWeight && maxValue >= EstimatedWeight)) {
        // Total Weight adjustment (-+0.5) condition check
        PreparedWeightVerifyChk = true;
      }

      if (
        SKUVerifyChk === true ||
        PreparedQtyErrorChk === true ||
        BoxErrorChk === true ||
        PreparedWeightVerifyChk === true
      ) {
        IsPreparedVerify = false;
      }

      orderPreparationProductModel.push({
        OrderProductID: val.OrderProductID,
        EstimatedWeight: val.EstimatedWeight,
        BoxNumbers: val.BoxNumbers,
        IsPreparedVerify: IsPreparedVerify,
        LotNumber: val.LotNumber,
      }); // order Product insert
    }

    orderPreparation.TypeOrderPreparationProductModel =
      orderPreparationProductModel;

    dispatch(orderActions.saveTemporaryOrderPreparation(orderPreparation));
  };

  // Product Save
  useEffect(() => {
    if (orderPreparationResponse === 1) {
      hideLoader();

      handleBack();
    } else if (orderPreparationResponse === 2) {
      hideLoader();

      handleBack();
    } else if (orderPreparationResponse === -1) {
      hideLoader();
      Toastr("Order Preparation error ", "warning");
    } else if (orderPreparationResponse < -1) {
      hideLoader();
      Toastr("Order Preparation error ", "warning");
    }
  }, [orderPreparationResponse]);

  //handling shortDesc open/close

  const handleShortDesc = (obj) => {
    setPopupData(obj);
    setShortDescModal(true);
  };

  const handlePackagesPerBox = (obj, index) => {
    setPackagesPerBox({
      isPackagesPerBox: true,
      isAdminPasscodeValid: false,
      OrderProductID: obj.OrderProductID,
      AdminPasscode: "",
      ProductName: obj.ProductName,
      ProductPerBoxCount: obj.ProductPerBoxCount,
      OrderPerBoxCount: "",
      index: index,
    });
    setIsRevealPwd(false);
  };
  const onClosePackagesPerBox = (obj) => {
    setPackagesPerBox({
      isPackagesPerBox: false,
      isAdminPasscodeValid: false,
      AdminPasscode: "",
      ProductName: "",
      ProductPerBoxCount: "",
      OrderPerBoxCount: "",
      index: null,
      OrderProductID: 0,
    });
  };
  const onSubmitPackagesPerBox = (obj) => {
    if (
      !packagesPerBox.OrderPerBoxCount ||
      packagesPerBox.OrderPerBoxCount.trim() === ""
    ) {
      Toastr("Please enter new packages per box", "warning");
      return;
    }
    let OrderPerBoxCountData = {
      OrderProductID: packagesPerBox.OrderProductID,
      AdminPasscode: packagesPerBox.AdminPasscode,
      ProductPerBoxCount: parseInt(packagesPerBox.ProductPerBoxCount),
      OrderPerBoxCount: parseInt(packagesPerBox.OrderPerBoxCount),
      CreatedBy: currentUser.Id,
    };
    dispatch(orderActions.updatePackagesPerBox(OrderPerBoxCountData)).then(
      (response) => {
        if (response.type === "order/updatePackagesPerBox/fulfilled") {
          if (response && response.payload === 1) {
            let orderDetailData = { ...orderDetail };
            let newFormData = [...orderDetailData.OrderProductModelList];
            // let rowData = { ...newFormData[packagesPerBox.index] };
            const index = newFormData.findIndex(
              // (x) => x.OrderProductID === packagesPerBox.OrderProductID,
              (x) =>
                String(x.OrderProductID) ===
                String(packagesPerBox.OrderProductID),
            );

            if (index === -1) {
              Toastr("Error updating packages per box", "warning");
              return;
            }

            let rowData = { ...newFormData[index] };
            // Update PerBoxCount
            rowData.PerBoxCount = parseInt(packagesPerBox.OrderPerBoxCount);

            // Convert string to number
            const qty = Number(rowData.Quantity);
            const perBox = Number(packagesPerBox.OrderPerBoxCount);

            // Safe division + 2 decimal formatting
            rowData.SplitBoxCount =
              perBox > 0 ? Number((qty / perBox).toFixed(2)) : 0;

            // newFormData[packagesPerBox.index] = rowData;
            newFormData[index] = rowData;
            orderDetailData.OrderProductModelList = newFormData;
            Toastr("Packages per box updated successfully", "success");
            dispatch(
              orderActions.tempSetOrderWeightVerification(orderDetailData),
            );
            onClosePackagesPerBox();
          } else {
            Toastr("Error updating packages per box", "warning");
          }
        } else {
          Toastr("Error updating packages per box", "warning");
        }
      },
    );
  };

  const onSubmitAdminPasscodeVerify = () => {
    if (
      !packagesPerBox.AdminPasscode ||
      packagesPerBox.AdminPasscode.trim() === ""
    ) {
      Toastr("Please enter admin passcode", "warning");
      return;
    }
    let adminPasscodeData = {
      Passcode: packagesPerBox.AdminPasscode,
    };

    dispatch(orderActions.verifyAdminPasscode(adminPasscodeData)).then(
      (response) => {
        if (response.type === "order/verifyAdminPasscode/fulfilled") {
          if (response && response.payload === 1) {
            Toastr("Admin passcode verified successfully", "success");
            setPackagesPerBox({
              ...packagesPerBox,
              isAdminPasscodeValid: true,
            });
          } else {
            Toastr("Invalid admin passcode", "warning");
          }
        } else {
          Toastr("Error verifying admin passcode", "warning");
        }
      },
    );
  };

  const hanldeShortDescClose = () => {
    setShortDescModal(false);
  };

  const handleNewPackagesChange = (e) => {
    let value = e.target.value;

    // Allow only digits
    value = value.replace(/[^0-9]/g, "");

    // Prevent starting with 0
    if (value.startsWith("0")) {
      value = value.replace(/^0+/, "");
    }

    // Max length 10 already handled by input, but keep safe:
    value = value.slice(0, 10);

    setPackagesPerBox({
      ...packagesPerBox,
      OrderPerBoxCount: value,
    });
  };

  return (
    <>
      <PageTitle activeMenu="Order Preparation" motherMenu="Order" />
      <ToastContainer />
      <BarcodeReader minLength={1} onError={handleError} onScan={handleScan} />
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title header-title">Order Preparation</h4>
              <div>
                {!serialPort && (
                  <>
                    <Button
                      variant="btn btn-primary"
                      onClick={connectToSerialPort}
                    >
                      Connect Weight Terminal
                    </Button>{" "}
                    &nbsp;
                  </>
                )}
                <Button
                  variant="btn btn-danger"
                  onClick={handleBack}
                  disabled={isBackButton}
                >
                  Back
                </Button>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-4 order-md-1">
                  <div className="mb-3">
                    <label className="text-black font-w700">Order ID</label>
                    <input
                      type="text"
                      name="txtQuantity"
                      placeholder="Order ID"
                      value={listView.OrderNumber}
                      readOnly={true}
                      className="form-control readonly_css"
                    ></input>
                  </div>
                </div>

                <div className="col-md-4 order-md-1">
                  <div className="mb-3">
                    <label className="text-black font-w700">Client Name</label>
                    <input
                      type="text"
                      name="txtClientName"
                      readOnly={true}
                      placeholder="Client Name"
                      value={listView.ClientName}
                      className="form-control readonly_css"
                    ></input>
                  </div>
                </div>

                <div className="col-md-4 order-md-1">
                  <div className="mb-3">
                    <label className="text-black font-w700">
                      Total Order Estimated Weight
                    </label>
                    <input
                      type="text"
                      readOnly={true}
                      name="TotalEstimatedWeight"
                      placeholder="Total Order Estimated Weight"
                      value={fFloat(orderPreparationData.TotalEstimatedWeight)}
                      className="form-control readonly_css"
                    ></input>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Product Details</h4>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div id="job_data" className="dataTables_wrapper">
                        <table
                          className="display w-100 dataTable "
                          id="example5"
                          role="grid"
                          aria-describedby="example5_info"
                        >
                          <thead>
                            <tr role="row">
                              <th
                                className="sorting_asc"
                                style={{ width: "177px" }}
                              >
                                Category
                              </th>
                              <th
                                className="sorting"
                                style={{ width: "200px" }}
                              >
                                Sub Category
                              </th>
                              {/* <th
                                className="sorting"
                                style={{ width: "200px" }}
                              >
                                Product
                              </th> */}
                              <th
                                className="sorting"
                                style={{ width: "200px", cursor: "pointer" }}
                                onClick={() => handleSort("ProductName")}
                              >
                                <span className="ml-1">
                                  Product
                                  {sortConfig.key === "ProductName" ? (
                                    sortConfig.direction === "desc" ? (
                                      <i className="fa fa-arrow-down" />
                                    ) : (
                                      <i className="fa fa-arrow-up" />
                                    )
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </th>
                              <th
                                className="sorting"
                                style={{ width: "200px" }}
                              >
                                Lot Number
                              </th>
                              {/* <th
                                className="sorting"
                                style={{ width: "200px" }}
                              >
                                Location
                              </th> */}
                              <th
                                className="sorting"
                                style={{ width: "200px", cursor: "pointer" }}
                                onClick={() => handleSort("Location")}
                              >
                                <span className="ml-1">
                                  Location
                                  {sortConfig.key === "Location" ? (
                                    sortConfig.direction === "desc" ? (
                                      <i className="fa fa-arrow-down" />
                                    ) : (
                                      <i className="fa fa-arrow-up" />
                                    )
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </th>
                              <th
                                className="sorting"
                                style={{ width: "200px" }}
                              >
                                SKU
                              </th>
                              <th
                                className="sorting"
                                style={{ width: "128px" }}
                              >
                                Unit Price
                              </th>
                              <th className="sorting" style={{ width: "46px" }}>
                                Ordered <br></br>
                                Quantity
                              </th>
                              <th className="sorting" style={{ width: "46px" }}>
                                Prepared <br></br> Quantity
                              </th>
                              <th className="sorting" style={{ width: "46px" }}>
                                Total Price
                              </th>
                              <th className="caps" style={{ width: "46px" }}>
                                Total Weight(lbs)
                              </th>
                              <th
                                className="sorting"
                                style={{ minWidth: "150px" }}
                              >
                                Box #
                              </th>
                              <th
                                className="caps"
                                style={{ minWidth: "150px" }}
                              >
                                Prepared Weight (lbs)
                              </th>
                              <th className="caps" style={{ minWidth: "46px" }}>
                                Action
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {orderDetail &&
                              orderDetail.OrderProductModelList &&
                              // orderDetail.OrderProductModelList.map(
                              sortedOrderProductModelList.map((obj, index) => (
                                <Fragment key={obj.OrderProductID}>
                                  {/* <tr className="odd" role="row"> */}
                                  <tr
                                    className="odd"
                                    role="row"
                                    data-order-product-id={obj.OrderProductID}
                                  >
                                    <td>
                                      <i
                                        className={`${
                                          obj.IsSKUVerify === true &&
                                          obj.IsPreparedQtyError === false &&
                                          (obj.IsPreparedVerify === true ||
                                            (obj.IsPreparedWeightVerify ===
                                              true &&
                                              !obj.EstimatedWeight))
                                            ? "fa fa-circle text-success PreparedWeightVerifyTxt"
                                            : ""
                                        }`}
                                      >
                                        <span className="PreparedWeightVerify">
                                          {" "}
                                          {obj.CategoryName}
                                        </span>
                                      </i>{" "}
                                    </td>
                                    <td>{obj.SubCategoryName}</td>
                                    <td>
                                      {
                                        <a
                                          className={`badge-rounded ${
                                            obj.WarrantyExpiryStatus === 1
                                              ? "badge badge-outline-danger"
                                              : obj.WarrantyExpiryStatus === 2
                                                ? "badge badge-outline-warning"
                                                : ""
                                          }`}
                                        >
                                          {obj.ProductName}
                                        </a>
                                      }
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        // className={`form-control ${
                                        //   obj.IsLotNumberchk === true &&
                                        //   !obj.LotNumber
                                        //     ? "border-danger"
                                        //     : obj.LotNumber &&
                                        //       obj.LotNumber > 0 &&
                                        //       "border-success"
                                        // }`}
                                        className={`form-control ${
                                          !obj.LotNumber
                                            ? "border-danger"
                                            : "border-success"
                                        }`}
                                        value={obj.LotNumber}
                                        placeholder="Lot Number"
                                        onChange={(e) =>
                                          handleChange(e, obj.OrderProductID)
                                        }
                                        onBlur={(e) =>
                                          handleBlur(e, obj.OrderProductID)
                                        }
                                        name="LotNumber"
                                        maxLength={10}
                                      />
                                    </td>
                                    <td>
                                      {" "}
                                      <a> {obj.Location}</a>
                                    </td>
                                    <td>
                                      <a
                                        className={`badge-rounded ${
                                          barcodeVerifySKU === obj.SKU &&
                                          "barcode-outline-verify"
                                        }`}
                                      >
                                        {obj.SKU}
                                      </a>
                                    </td>
                                    <td>{fCurrency(obj.UnitPrice)}</td>
                                    <td>{fNumber(obj.Quantity)}</td>
                                    <td>
                                      <input
                                        type="text"
                                        className={`form-control ${
                                          obj.IsPreparedQtyError === true ||
                                          (!obj.PreparedQuantity &&
                                            obj.IsSKUVerify === true)
                                            ? "border-danger"
                                            : obj.PreparedQuantity &&
                                              obj.PreparedQuantity > 0 &&
                                              "border-success"
                                        } ${
                                          obj.IsSKUVerify === false &&
                                          "readonly_css"
                                        }`}
                                        onChange={(e) =>
                                          handleChange(e, obj.OrderProductID)
                                        }
                                        value={obj.PreparedQuantity}
                                        name="PreparedQuantity"
                                        readOnly={
                                          obj.IsSKUVerify === true
                                            ? false
                                            : true
                                        }
                                        // autoFocus={barcodeVerifySKU === obj.SKU ? true : false}

                                        // ref={(e) => (barcodeVerifySKU === obj.SKU && e.focus())}
                                      />
                                    </td>
                                    <td>{fCurrency(obj.Total)}</td>
                                    <td>
                                      {fFloat(
                                        (obj.Weight && obj.Weight) *
                                          (obj.Quantity && obj.Quantity),
                                      )}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        onChange={(e) =>
                                          handleChange(e, obj.OrderProductID)
                                        }
                                        value={obj.BoxNumbers}
                                        onBlur={(e) =>
                                          handleBlur(e, obj.OrderProductID)
                                        }
                                        className={`form-control  ${
                                          obj.IsBoxError === true ||
                                          (!obj.BoxNumbers &&
                                            obj.IsSKUVerify === true)
                                            ? "border-danger"
                                            : ""
                                        }   ${
                                          obj.IsSKUVerify === false &&
                                          "readonly_css"
                                        }`}
                                        name="BoxNumbers"
                                        readOnly={
                                          obj.IsSKUVerify === true
                                            ? false
                                            : true
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        onChange={(e) =>
                                          handleChange(e, obj.OrderProductID)
                                        }
                                        value={obj.EstimatedWeight}
                                        onBlur={(e) =>
                                          handleBlur(e, obj.OrderProductID)
                                        }
                                        className={`form-control ${
                                          (obj.IsPreparedWeightVerify ===
                                            false &&
                                            obj.IsSKUVerify === true) ||
                                          (!obj.EstimatedWeight &&
                                            obj.IsSKUVerify === true)
                                            ? "border-danger"
                                            : ""
                                        } ${
                                          obj.IsSKUVerify === false &&
                                          "readonly_css"
                                        }`}
                                        name="EstimatedWeight"
                                        readOnly={
                                          obj.IsSKUVerify === true
                                            ? false
                                            : true
                                        }
                                      />
                                    </td>
                                    <td className="text-center align-middle">
                                      <div className="d-flex justify-content-center align-items-center gap-2">
                                        <div
                                          onClick={() => handleShortDesc(obj)}
                                          className="btn btn-primary-color shadow btn-xs sharp"
                                          title="Short Desc"
                                        >
                                          <i className="fas fa-info"></i>
                                        </div>

                                        <div
                                          onClick={() =>
                                            handlePackagesPerBox(obj, index)
                                          }
                                          className="btn btn-primary-color shadow btn-xs sharp"
                                          title="Packages Per Box"
                                        >
                                          <i className="fa fa-box"></i>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </Fragment>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <h4>
                    <b style={{ float: "right", padding: "0px 92px 0px 0px" }}>
                      Grand Total : {fCurrency(orderDetail.GrandTotal)}
                    </b>
                  </h4>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-12">
                  <button
                    type="button"
                    onClick={() => handleSave()}
                    style={{ float: "right" }}
                    className="btn btn-primary mb-2"
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    onClick={() => handleTemporarySave()}
                    style={{ float: "right", marginRight: "6px" }}
                    className="btn btn-primary mb-2"
                  >
                    Save Temporary
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {popupData && Object.keys(popupData).length > 0 && (
        <WeightVerificationPopup
          modalControl={isShortDescModal}
          data={popupData}
          onClose={hanldeShortDescClose}
        />
      )}

      <Modal
        className="fade bd-example-modal-lg"
        show={packagesPerBox.isPackagesPerBox}
        size="md"
      >
        <Modal.Header>
          <Modal.Title>{packagesPerBox?.ProductName}</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={onClosePackagesPerBox}
          ></Button>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            {/* Description */}
            <div className="col-12 mb-3">
              <label htmlFor="adminPasscode" className="form-label">
                Admin Passcode <span className="text-danger">*</span>
              </label>
              <div className="input-group mb-3">
                <input
                  id="adminPasscode"
                  type={isRevealPwd ? "text" : "password"}
                  maxLength="10"
                  className={`form-control ${
                    packagesPerBox?.isAdminPasscodeValid ? "readonly_css" : ""
                  }`}
                  value={packagesPerBox.AdminPasscode}
                  onChange={(e) =>
                    setPackagesPerBox({
                      ...packagesPerBox,
                      AdminPasscode: e.target.value,
                    })
                  }
                  readOnly={packagesPerBox?.isAdminPasscodeValid}
                />
                <span className="input-group-text togglePassword">
                  <i
                    title={isRevealPwd ? "Hide" : "Show"}
                    className={
                      isRevealPwd
                        ? "fa fa-eye-slash PasswordHideShow"
                        : "fa fa-eye PasswordHideShow"
                    }
                    onClick={() => setIsRevealPwd(!isRevealPwd)}
                  />
                </span>
              </div>
            </div>

            {packagesPerBox?.isAdminPasscodeValid && (
              <>
                <div className="col-12 mb-3">
                  <label className="form-label">Product Packages Per Box</label>
                  <input
                    type="number"
                    className="form-control readonly_css"
                    value={packagesPerBox?.ProductPerBoxCount || ""}
                    readOnly
                  />
                </div>

                {/* New Packages Per Box */}
                <div className="col-12 mb-3">
                  <label className="form-label">
                    New Packages Per Box <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={packagesPerBox.OrderPerBoxCount}
                    onChange={handleNewPackagesChange}
                  />
                </div>
              </>
            )}
            {/* Old Packages Per Box (readonly) */}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger light" onClick={onClosePackagesPerBox}>
            Close
          </Button>
          <Button
            variant="secondary"
            onClick={
              packagesPerBox.isAdminPasscodeValid === true
                ? onSubmitPackagesPerBox
                : onSubmitAdminPasscodeVerify
            }
          >
            {packagesPerBox.isAdminPasscodeValid === true ? "Submit" : "Verify"}
          </Button>
        </Modal.Footer>
      </Modal>

      {loader}
    </>
  );
};
export default WeightVerification;
